import dayjs from 'dayjs'

import { getDemoUrl, getScoutContext } from "./scout"
import { clearAuthSession } from "./auth"

let isLoggingOut = false

export const handleUnauthorized = () => {
	if (isLoggingOut) return
	isLoggingOut = true
	clearAuthSession()
	window.location.href = "/login"
}

export const getMaxLicenses = (enterprise) => 
	enterprise?.plan?.products?.find(
		(p) => p?.product?.name === "scout_number"
	)?.quantity || 0

export const getMaxAdmins = (enterprise) => 
	enterprise?.plan?.products?.find(
		(p) => p?.product?.name === "scout_supervisor"
	)?.quantity || 0

export const isTrial = (enterprise) => enterprise?.plan?.name === "Scout Trial"
export const isFreePlan = (enterprise) => enterprise?.plan?.name === "Scout Free"

export const getPlanEndDate = (enterprise) => enterprise?.end_charging

export const isTrialExpired = (enterprise) => {
	if (!isTrial(enterprise)) return false
	const planEndDate = getPlanEndDate(enterprise)
	if (!planEndDate) return false
	const trialEndAt = dayjs(planEndDate)
	if (!trialEndAt.isValid()) return false
	return trialEndAt.startOf('day').diff(dayjs().startOf('day'), 'day') < 0
}

export const isCancelled = (enterprise) => String(enterprise?.charge_status || '').trim().toUpperCase() === "CANCELLED"
export const isDefaulter = (enterprise) => String(enterprise?.charge_status || '').trim().toUpperCase().startsWith("DEFAULTER")
export const isAccountBlocked = (enterprise) => isTrialExpired(enterprise) || isCancelled(enterprise) || isDefaulter(enterprise)

export const renderBubbleChart = (enterprise) =>
	!!enterprise?.plan?.products?.some(
		(p) => p?.product?.name === "scout_ai_features" && p?.quantity >= 1
	)

export const renderSatisfactionChart = (enterprise) =>
	!!enterprise?.plan?.products?.some(
		(p) => p?.product?.name === "scout_ai_features" && p?.quantity >= 1
	)

export const renderSummaryChart = (enterprise) =>
	!!enterprise?.plan?.products?.some(
		(p) => p?.product?.name === "scout_ai_features" && p?.quantity >= 1
	)

export const renderAIFeatures = (enterprise) =>
	!!enterprise?.plan?.products?.some(
		(p) => p?.product?.name === "scout_ai_features" && p?.quantity >= 1
	)

export const renderCRMFeatures = (enterprise) =>
	!!enterprise?.plan?.products?.some(
		(p) => p?.product?.name === "scout_crm" && p?.quantity >= 1
	)

export const renderExceptions = (enterprise) =>
	!!enterprise?.plan?.products?.some(
		(p) => p?.product?.name === "scout_exceptions" && p?.quantity >= 1
	)

export const renderKeywords = (enterprise) =>
	!!enterprise?.plan?.products?.some(
		(p) => p?.product?.name === "scout_keywords" && p?.quantity >= 1
	)

export const renderExportConversation = (enterprise) =>
	!!enterprise?.plan?.products?.some(
		(p) => p?.product?.name === "scout_export_manual" && p?.quantity >= 1
	)

export const renderExportAutomatic = (enterprise) =>
	!!enterprise?.plan?.products?.some(
		(p) => p?.product?.name === "scout_export_automatic" && p?.quantity >= 1
	)

export const getSupportType = (enterprise) => {
	const products = enterprise?.plan?.products || []

	const hasProduct = (name) =>
		products.some(
			(p) => p?.product?.name === name && p?.quantity >= 1
		)

	if (hasProduct("scout_manager")) return "manager"
	if (hasProduct("scout_support_builder")) return "priority"

	// return "email" // Temporarily deprecated
	return
}

const MESSAGE_TYPE_TO_MEDIA = {
	imageMessage: 'image',
	videoMessage: 'video',
	audioMessage: 'audio',
	documentMessage: 'document',
	documentWithCaptionMessage: 'document',
	stickerMessage: 'sticker',
	eventMessage: 'event',
	locationMessage: 'location',
	liveLocationMessage: 'location',
	contactMessage: 'contact',
	pollCreationMessageV3: 'poll_creaction_message_v3',
}

export const isMessageTypeAllowedForEnterprise = (messageType, enterprise, gifPlayback = false) => {
	const allowed = enterprise?.scout_allowed_media_types

	if (allowed === null || allowed === undefined || !Array.isArray(allowed)) {
		return true
	}

	if (allowed.includes('all')) {
		return true
	}

	if (allowed.length === 0) {
		return false
	}

	let normalizedType = MESSAGE_TYPE_TO_MEDIA[messageType]

	if (!normalizedType) {
		return true
	}

	if (normalizedType === 'video' && gifPlayback) {
		normalizedType = 'gif'
	}

	return allowed.includes(normalizedType)
}

export const getManagerUrl = (enterprise) => {
    const telephone = enterprise?.manager?.telephone

    if (!telephone) {
    	throw new Error("Manager telephone not available")
    }

    let digits = telephone.replace(/\D/g, "")
    
    if (!digits.startsWith("55"))
        digits = `55${digits}`

    const message = encodeURIComponent("Olá, preciso de ajuda com minha conta.")

    return `https://wa.me/+${digits}?text=${message}`
}

export const scheduleDemo = async () => {
	const demoUrl = await getDemoUrl()
	window.open(demoUrl, "_blank")
}

export const userHasGroup = (groups) => {
	const { user } = getScoutContext()
	if (!user?.groups?.length || !groups?.length)
		return false
	return user.groups.some(userGroup =>
		groups.includes(userGroup.name)
	)
}
